export default "__VITE_ASSET__DWUrHTK5__"